var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row row-first row-single setting" }, [
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "col col-100" }, [
            _c("span", { staticClass: "row__title" }, [
              _vm._v("Huidige tegoed")
            ]),
            _c("br"),
            _vm._v("\n      € " + _vm._s(_vm.data.credit) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [
              _vm._v("Huidige tegoed")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__subtitle" }, [
              _vm._v(
                "€ " +
                  _vm._s(_vm.roundedCosts.toLocaleString()) +
                  " (" +
                  _vm._s(_vm.roundedMinutesData) +
                  " min*)"
              )
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c("div", { staticClass: "rows" }, [
      _c(
        "a",
        {
          attrs: { href: _vm.data.topUpCreditUrl, target: "_blank" },
          on: {
            click: function($event) {
              return _vm.backToDashboardClick()
            }
          }
        },
        [_vm._m(3)]
      )
    ]),
    _vm._v(" "),
    this.subscription.renewal == true
      ? _c("div", [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "rows" }, [
            _c(
              "a",
              {
                attrs: { href: _vm.data.extendUrl, target: "_blank" },
                on: {
                  click: function($event) {
                    return _vm.backToDashboardClick()
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "row row-single setting subscription" },
                  [
                    _c("div", {
                      staticClass: "avatar avatar--prepaid-subscription"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "account-info" }, [
                      _c("div", { staticClass: "table" }, [
                        _c("div", { staticClass: "cell" }, [
                          _c("div", { staticClass: "account-info__title" }, [
                            _vm._v("Maandbundel verlengen")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "account-info__subtitle" }, [
                            _c("p", [
                              _vm._v(
                                "Om de app te gebruiken heb je een maandbundel nodig"
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("Betalen kan via iDeal / betaallink")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "account-info__subtitle--large" },
                              [
                                _vm._v(
                                  "jouw bundel verloopt op " +
                                    _vm._s(this.subscription.initialExpireTime)
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Tegoed")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row explanation" }, [
      _c("div", { staticClass: "col col-100" }, [
        _vm._v(
          "\n                  * Elke belminuut of startminuut kost € 0,06 afhankelijk van hoeveelheid gesprekken en de lengte van de gesprekken kan dit enigszins afwijken.\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Beltegoed ophogen")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row row-single setting subscription" }, [
      _c("div", { staticClass: "avatar avatar--prepaid-minutes" }),
      _vm._v(" "),
      _c("div", { staticClass: "account-info" }, [
        _c("div", { staticClass: "table" }, [
          _c("div", { staticClass: "cell" }, [
            _c("div", { staticClass: "account-info__title" }, [
              _vm._v("Belminuten aanschaffen")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "account-info__subtitle" }, [
              _c("p", [_vm._v("Je hebt de keuze uit 100/200/300/400 min")]),
              _vm._v(" "),
              _c("p", [_vm._v("Betalen kan via iDeal / betaallink")]),
              _vm._v(" "),
              _c("p", { staticClass: "account-info__subtitle--large" }, [
                _vm._v("vanaf € 4,99 incl btw")
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Bundel verlengen")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b47a6ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b47a6ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Credit.vue
// module id = null
// module chunks = 